"use client";

import WebsiteIcon from "@/icons/WebsiteIcon";
import { hasWebsiteIcon } from "@/icons/icon-catalogue";
import { getRounded, ownRadiusStyle } from "@/utils/theme-helper";
import parse, { Element } from "html-react-parser";

export interface SvgComponentProps {
  svg: string;
  iconId?: string | null;
  textColor?: string;
  height?: string;
  width?: string;
  margin?: string;
  padding?: string;
  bgColor?: string;
  rounded?: string;
  /** On a look-system website, where `rounded` may be an exact length. */
  lookSystem?: boolean;
}

const SvgComponent: React.FC<{
  config: SvgComponentProps;
}> = ({ config }) => {
  if (hasWebsiteIcon(config.iconId))
    return (
      <WebsiteIcon
        name={config.iconId}
        className={getRounded(config.rounded, config.lookSystem)}
        style={{
          ...ownRadiusStyle(config.rounded, config.lookSystem),
          display: "inline-block",
          width: config.width || "32px",
          height: config.height || "32px",
          color: config.textColor || "inherit",
          margin: config.margin,
          padding: config.padding,
          backgroundColor: config.bgColor,
        }}
      />
    );
  if (!config.svg) {
    return null;
  }

  const style = `${config.height ? `height: ${config.height};` : ""} ${config.width ? `width: ${config.width};` : ""} ${config.margin ? `margin: ${config.margin};` : ""} ${config.padding ? `padding: ${config.padding};` : ""} ${config.bgColor ? `background-color: ${config.bgColor};` : ""}${Object.entries(
    ownRadiusStyle(config.rounded, config.lookSystem),
  )
    .map(([name, value]) => ` ${name}: ${value};`)
    .join("")}`;

  const parsedSvg = parse(config.svg, {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs) {
        domNode.attribs["fill"] = "currentColor";
        domNode.attribs["color"] = config.textColor ?? "inherit";
        domNode.attribs["style"] = style;
        domNode.attribs["class"] =
          `${getRounded(config.rounded, config.lookSystem)}`;
      }
    },
  });

  return parsedSvg;
};

export default SvgComponent;
